import Header from "../../../components/common/header";
import { gql } from "../../../__generated__";
import { useQuery } from "@apollo/client";
import LoadingSpinnerFull from "../../../components/common/loading-spinner/loading-spinner-full";
import OrderList from "../order-list";

export const WRITABLE_REVIEW_ORDERS_BY_USER = gql(`
  query writableReviewOrdersByUser {
    writableReviewOrdersByUser {
      id
      createdAt
      amount
      products {
        store {
          title
        }
        menus {
          id
          img
        }
        img
      }
      pickUpTime
      totalDiscount
      totalQuantity
      isCanceled
      isPackConfirmed
      pack {
        id
        store {
          title
          img
          reserveTime
        }
      }
      packId
      review {
        id
        status
      }
      reviewWriteStatus
    }
  }
`);

const OrderWritableReview = () => {
  const { data, loading } = useQuery(WRITABLE_REVIEW_ORDERS_BY_USER, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <LoadingSpinnerFull />;
  }

  return (
    <div className="w-full min-h-screen h-full flex flex-col overflow-y-scroll">
      <Header title="작성할 수 있는 리뷰" showBackButton />

      <div className="w-full flex flex-col gap-4">
        <OrderList order={data?.writableReviewOrdersByUser as any[]} />
      </div>
    </div>
  );
};

export default OrderWritableReview;
